export default [
  {
    add_to_order: "Tilføj til ordre",
    opening_times: "Åbningstider",
    deliveryHours: "Leveringstider",
    seeMoreInfo: "Se mere information",
    restaurant_information: "Restaurant oplysninger",
    store_name: "Butiksnavn",
    discount: "rabat",
    store_not_configured: "Butik er ikke konfigureret endnu.",
    store_offline: "Vi er offline lige nu, prøv igen senere.",
  },
];
